module.exports = __webpack_public_path__ + "static/media/ChampionsSprite.27bb5840.png";